import React from 'react';
import { Box, Typography } from '@mui/material';
import i18n from '../../../i18';
import { fDate } from '../../../utils/formatTime';

class DialogTextField extends React.Component {
    render() {
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const highlighted = this.props.field.style === 'highlighted';
        const value = this.props.value[this.props.field.id];
        const date = this.props.field.cell === 'Date';
        return (
            <>
                {date ? (
                    <Box mb={2} display="flex" justifyContent="space-between">
                        <Typography variant="subtitle2">
                            {translatedLabel}
                        </Typography>
                        <Typography sx={{ fontWeight: '600' }}>
                            {fDate(value)}
                        </Typography>
                    </Box>
                ) : (
                    <Box mb={2}>
                        <Typography variant="subtitle2">
                            {translatedLabel}
                        </Typography>
                        <Typography
                            sx={
                                highlighted
                                    ? {
                                        color: 'primary.main',
                                        fontWeight: '600'
                                    }
                                    : { fontWeight: '600' }
                            }
                        >
                            {value}
                        </Typography>
                    </Box>
                )}
            </>
        );
    }
}

export default DialogTextField;
